// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { angrybirds_regular, initializeFonts } from "../code/AssetDefinitions/FontDefinitions";
import { s_rank_emblem_wood, s_slingshot_front, s_slingshot_back, s_rank_emblem_bronze, s_slingshot_front_bronze, s_slingshot_back_bronze, s_rank_emblem_silver, s_slingshot_front_silver, s_slingshot_back_silver, s_rank_emblem_gold, s_slingshot_front_gold, s_slingshot_back_gold, s_rank_emblem_azure, s_slingshot_front_azure, s_slingshot_back_azure, s_rank_emblem_emerald, s_slingshot_front_emerald, s_slingshot_back_emerald, s_rank_emblem_amethyst, s_slingshot_front_amethyst, s_slingshot_back_amethyst, s_rank_emblem_diamond, s_slingshot_front_diamond, s_slingshot_back_diamond, s_rank_emblem_elder_silver, s_slingshot_front_elder_silver, s_slingshot_back_elder_silver, s_rank_emblem_elder_gold, s_slingshot_front_elder_gold, s_slingshot_back_elder_gold, s_portrait_01, s_portrait_02, s_portrait_03, s_portrait_04, s_portrait_05, s_portrait_06, s_portrait_07, m_01, m_02, m_03, m_04, m_05, m_06, m_07, m_08, m_09, m_10, m_11, m_12, m_13, m_14, m_15, m_16, m_17, m_18, m_19, m_20, m_21, m_22, m_23, m_24, m_25, f_01, f_02, f_03, f_04, f_05, f_06, f_07, f_08, f_09, f_10, f_11, f_12, f_13, f_14, f_15, f_16, f_17, f_18, f_19, f_20, f_21, f_22, f_23, f_24, f_25, s_powerup_tnt, s_buttonpower_red, s_powerup_shield, s_buttonpower_teal, s_powerup_freeze, s_buttonpower_blue_light, s_powerup_stone_nator, s_buttonpower_grey, s_powerup_pig_swap, s_buttonpower_green } from "../code/AssetDefinitions/ImageDefinitions";
import { l_level_crane, l_level_crane_extra, l_level_floatingcity, l_level_floatingcity_extra, l_level_poolparty, l_level_poolparty_extra, l_level_balloonfortress, l_level_balloonfortress_extra, l_level_castle, l_level_castle_extra, l_level_ship, l_level_ship_extra, l_level_manybuildings, l_level_manybuildings_extra, l_level_airtemple, l_level_airtemple_extra, l_level_industrial, l_level_industrial_extra, l_level_airfield, l_level_airfield_extra, l_level_fortress, l_level_fortress_extra, l_level_harbour, l_level_harbour_extra, l_level_train, l_level_train_extra, l_level_tutorial, l_level_tutorial_extra, l_level_blackbeard, l_level_blackbeard_extra, l_level_forestpicnic, l_level_forestpicnic_extra, l_level_fullhouse, l_level_fullhouse_extra, l_level_battlefield, l_level_battlefield_extra, l_level_beach, l_level_beach_extra } from "../code/AssetDefinitions/JsonDefinitions";
export var Settings = {};
// TODO: Move these somewhere else?
// initializeImages();
initializeFonts();
export var LevelSettings = {
    levelList: [
        { level: l_level_crane, levelExtra: l_level_crane_extra },
        { level: l_level_floatingcity, levelExtra: l_level_floatingcity_extra },
        { level: l_level_poolparty, levelExtra: l_level_poolparty_extra },
        { level: l_level_balloonfortress, levelExtra: l_level_balloonfortress_extra },
        { level: l_level_castle, levelExtra: l_level_castle_extra },
        { level: l_level_ship, levelExtra: l_level_ship_extra },
        { level: l_level_manybuildings, levelExtra: l_level_manybuildings_extra },
        { level: l_level_airtemple, levelExtra: l_level_airtemple_extra },
        { level: l_level_industrial, levelExtra: l_level_industrial_extra },
        { level: l_level_airfield, levelExtra: l_level_airfield_extra },
        { level: l_level_fortress, levelExtra: l_level_fortress_extra },
        { level: l_level_harbour, levelExtra: l_level_harbour_extra },
        { level: l_level_train, levelExtra: l_level_train_extra },
        { level: l_level_tutorial, levelExtra: l_level_tutorial_extra },
        { level: l_level_blackbeard, levelExtra: l_level_blackbeard_extra },
        { level: l_level_forestpicnic, levelExtra: l_level_forestpicnic_extra },
        { level: l_level_fullhouse, levelExtra: l_level_fullhouse_extra },
        { level: l_level_battlefield, levelExtra: l_level_battlefield_extra },
        { level: l_level_beach, levelExtra: l_level_beach_extra },
    ],
    nonRandomLevels: [13]
};
export var ExpSettings = {
    rankExpRequirements: [
        0,
        100,
        250,
        500,
        750,
        1000,
        2500,
        5000,
        7500,
        10000
    ],
    rankAssets: [
        {
            emblem: s_rank_emblem_wood,
            front: s_slingshot_front,
            back: s_slingshot_back
        },
        {
            emblem: s_rank_emblem_bronze,
            front: s_slingshot_front_bronze,
            back: s_slingshot_back_bronze
        },
        {
            emblem: s_rank_emblem_silver,
            front: s_slingshot_front_silver,
            back: s_slingshot_back_silver
        },
        {
            emblem: s_rank_emblem_gold,
            front: s_slingshot_front_gold,
            back: s_slingshot_back_gold
        },
        {
            emblem: s_rank_emblem_azure,
            front: s_slingshot_front_azure,
            back: s_slingshot_back_azure
        },
        {
            emblem: s_rank_emblem_emerald,
            front: s_slingshot_front_emerald,
            back: s_slingshot_back_emerald
        },
        {
            emblem: s_rank_emblem_amethyst,
            front: s_slingshot_front_amethyst,
            back: s_slingshot_back_amethyst
        },
        {
            emblem: s_rank_emblem_diamond,
            front: s_slingshot_front_diamond,
            back: s_slingshot_back_diamond
        },
        {
            emblem: s_rank_emblem_elder_silver,
            front: s_slingshot_front_elder_silver,
            back: s_slingshot_back_elder_silver
        },
        {
            emblem: s_rank_emblem_elder_gold,
            front: s_slingshot_front_elder_gold,
            back: s_slingshot_back_elder_gold
        },
    ],
    expGain: {
        win: 100,
        loss: 50,
    }
};
export var NameSettings = {
    bombDrop: "BombDrop",
    shield: "Shield",
    freezeRay: "FreezeRay",
    stoneNator: "StoneNator",
    swapPigs: "SwapPigs",
    blackBird: "BlackBird",
    yellowBird: "YellowBird",
    redBird: "RedBird",
    blueBird: "BlueBird",
    bigBird: "BigBird",
    matilda: "Matilda"
};
export var SinglePlayerOpponents = [
    { id: "ai_opponent_0", name: "Red", image: s_portrait_01 },
    { id: "ai_opponent_1", name: "Chuck", image: s_portrait_02 },
    { id: "ai_opponent_2", name: "Matilda", image: s_portrait_03 },
    { id: "ai_opponent_3", name: "Blues", image: s_portrait_04 },
    { id: "ai_opponent_4", name: "Bomb", image: s_portrait_05 },
    { id: "ai_opponent_5", name: "Silver", image: s_portrait_06 },
    { id: "ai_opponent_6", name: "Terence", image: s_portrait_07 }
];
export var FakeOpponents = [
    { id: "fake_m_01", image: m_01, name: "Daniel" },
    { id: "fake_m_02", image: m_02, name: "Kiyoshi" },
    { id: "fake_m_03", image: m_03, name: "Thomas" },
    { id: "fake_m_04", image: m_04, name: "Ravi" },
    { id: "fake_m_05", image: m_05, name: "Yong" },
    { id: "fake_m_06", image: m_06, name: "Kenny" },
    { id: "fake_m_07", image: m_07, name: "Garrel" },
    { id: "fake_m_08", image: m_08, name: "Hunter" },
    { id: "fake_m_09", image: m_09, name: "Destin" },
    { id: "fake_m_10", image: m_10, name: "Basim" },
    { id: "fake_m_11", image: m_11, name: "Dan" },
    { id: "fake_m_12", image: m_12, name: "Carlos" },
    { id: "fake_m_13", image: m_13, name: "Cliff" },
    { id: "fake_m_14", image: m_14, name: "Clyde" },
    { id: "fake_m_15", image: m_15, name: "Austin" },
    { id: "fake_m_16", image: m_16, name: "Brian" },
    { id: "fake_m_17", image: m_17, name: "Phillip" },
    { id: "fake_m_18", image: m_18, name: "Greg" },
    { id: "fake_m_19", image: m_19, name: "Martin" },
    { id: "fake_m_20", image: m_20, name: "Michael" },
    { id: "fake_m_21", image: m_21, name: "Blake" },
    { id: "fake_m_22", image: m_22, name: "Zack" },
    { id: "fake_m_23", image: m_23, name: "Mark" },
    { id: "fake_m_24", image: m_24, name: "Steve" },
    { id: "fake_m_25", image: m_25, name: "Jake" },
    { id: "fake_f_01", image: f_01, name: "Gigi" },
    { id: "fake_f_02", image: f_02, name: "Jing" },
    { id: "fake_f_03", image: f_03, name: "Yoshie" },
    { id: "fake_f_04", image: f_04, name: "Song" },
    { id: "fake_f_05", image: f_05, name: "Ming" },
    { id: "fake_f_06", image: f_06, name: "Candence" },
    { id: "fake_f_07", image: f_07, name: "Cassandra" },
    { id: "fake_f_08", image: f_08, name: "Daniella" },
    { id: "fake_f_09", image: f_09, name: "Elayah" },
    { id: "fake_f_10", image: f_10, name: "Fionna" },
    { id: "fake_f_11", image: f_11, name: "Ezra" },
    { id: "fake_f_12", image: f_12, name: "Demi" },
    { id: "fake_f_13", image: f_13, name: "Chelsea" },
    { id: "fake_f_14", image: f_14, name: "Feleysa" },
    { id: "fake_f_15", image: f_15, name: "Jamacia" },
    { id: "fake_f_16", image: f_16, name: "Natalie" },
    { id: "fake_f_17", image: f_17, name: "Allison" },
    { id: "fake_f_18", image: f_18, name: "Ashley" },
    { id: "fake_f_19", image: f_19, name: "Emily" },
    { id: "fake_f_20", image: f_20, name: "Maddy" },
    { id: "fake_f_21", image: f_21, name: "Sarah" },
    { id: "fake_f_22", image: f_22, name: "Tara" },
    { id: "fake_f_23", image: f_23, name: "Kristen" },
    { id: "fake_f_24", image: f_24, name: "Kelly" },
    { id: "fake_f_25", image: f_25, name: "Aylin" }
];
export var AISettings = {
    // Wait for this number of seconds after the bird first impact
    secondsToWaitAfterImpact: 5,
    // matches expire after this time
    matchDurationInMiliseconds: (72 * 3600 * 1000),
    // The probability of the AI to use a powerup (between 0 and 1)
    chanceToUsePowerup: 0.2,
    // Wait for this number of seconds after the using a powerup
    secondsToWaitAfterPowerup: 5,
    // Wait for this number of seconds after deciding not to use a powerup
    secondsToWaitAfterNoPowerup: 0,
    angleMinOffset: 6,
    angleMaxOffset: 11,
    practiceLevels: [13],
};
export var AIFakeRandomSettings = {
    // Wait for this number of seconds after the bird first impact
    secondsToWaitAfterImpact: 5,
    // matches expire after this time
    matchDurationInMiliseconds: (72 * 3600 * 1000),
    // The probability of the AI to use a powerup (between 0 and 1)
    chanceToUsePowerup: 0.35,
    // Wait for this number of seconds after the using a powerup
    secondsToWaitAfterPowerup: 5,
    // Wait for this number of seconds after deciding not to use a powerup
    secondsToWaitAfterNoPowerup: 2,
    angleMinOffset: 6,
    angleMaxOffset: 11
};
export var skillRankSettings = [
    {
        rankName: "Student",
        pointRequirement: 0,
        minExpRank: 2,
        maxExpRank: 2,
        AISettings: {
            chanceToUsePowerup: 0,
            angleMinOffset: 5,
            angleMaxOffset: 12,
            birdOptions: [
                { fromTurn: 0, lastTurn: 99, options: [
                        { bird: NameSettings.redBird, chance: 1, max: 2 },
                        { bird: NameSettings.blueBird, chance: 1, max: 2 },
                        { bird: NameSettings.yellowBird, chance: 1, max: 2 }
                    ]
                }
            ]
        }
    },
    {
        rankName: "Beginner",
        pointRequirement: 1,
        minExpRank: 2,
        maxExpRank: 4,
        AISettings: {
            chanceToUsePowerup: 0.1,
            angleMinOffset: 3,
            angleMaxOffset: 11,
            birdOptions: [
                { fromTurn: 0, lastTurn: 99, options: [
                        { bird: NameSettings.redBird, chance: 1, max: 2 },
                        { bird: NameSettings.blueBird, chance: 1, max: 2 },
                        { bird: NameSettings.yellowBird, chance: 1, max: 2 },
                        { bird: NameSettings.blackBird, chance: 1, max: 1 }
                    ]
                }
            ]
        }
    },
    {
        rankName: "Intermediate",
        pointRequirement: 6,
        minExpRank: 3,
        maxExpRank: 6,
        AISettings: {
            chanceToUsePowerup: 0.35,
            angleMinOffset: 2,
            angleMaxOffset: 8,
            birdOptions: [
                { fromTurn: 0, lastTurn: 99, options: [
                        { bird: NameSettings.redBird, chance: 25, max: 2 },
                        { bird: NameSettings.blueBird, chance: 25, max: 2 },
                        { bird: NameSettings.yellowBird, chance: 25, max: 2 },
                        { bird: NameSettings.blackBird, chance: 25, max: 1 },
                        { bird: NameSettings.bigBird, chance: 1, max: 1 }
                    ]
                }
            ]
        }
    },
    {
        rankName: "Skilled",
        pointRequirement: 12,
        minExpRank: 5,
        maxExpRank: 8,
        AISettings: {
            chanceToUsePowerup: 0.7,
            angleMinOffset: 1,
            angleMaxOffset: 6,
            birdOptions: [
                { fromTurn: 0, lastTurn: 99, options: [
                        { bird: NameSettings.redBird, chance: 25, max: 2 },
                        { bird: NameSettings.blueBird, chance: 25, max: 1 },
                        { bird: NameSettings.yellowBird, chance: 25, max: 2 },
                        { bird: NameSettings.blackBird, chance: 25, max: 1 },
                        { bird: NameSettings.bigBird, chance: 1, max: 1 }
                    ]
                }
            ]
        }
    },
    {
        rankName: "Expert",
        pointRequirement: 18,
        maximumPoints: 25,
        minExpRank: 7,
        maxExpRank: 10,
        AISettings: {
            chanceToUsePowerup: 0.9,
            angleMinOffset: 1,
            angleMaxOffset: 4,
            birdOptions: [
                { fromTurn: 0, lastTurn: 99, options: [
                        { bird: NameSettings.redBird, chance: 25, max: 2 },
                        { bird: NameSettings.blueBird, chance: 25, max: 1 },
                        { bird: NameSettings.yellowBird, chance: 25, max: 2 },
                        { bird: NameSettings.blackBird, chance: 25, max: 1 },
                        { bird: NameSettings.bigBird, chance: 1, max: 1 }
                    ]
                }
            ]
        }
    }
];
export var CameraSettings = {
    "cameraShake": { "intensity": 250, "fade": 0.75, "birdImpactShake": 0.01, "explosionShake": 0.4 },
    "shootZoom": 11.0,
    "extraSpaceDivider": 2.5,
    "panRubberBanding": 0.99,
    "cameraYOffset": 8,
    "zoomRubberBanding": 0.6,
    "birdZoomMargin": 175,
    "birdZoomSmoothing": 0.020,
    "birdTrackSmoothing": 0.15,
    "birdLaunchMargin": 350,
    "slingshotTrackSpeed": 0.1,
    "birdClickZoomSpeed": 0.05,
    "birdClickPanSpeed": 0.1,
    "birdClickKeyTime": 1.5,
    "birdClickX": -0.6,
    "birdClickY": -0.75 // ^^
};
export var PigSettings = {
    idleAnimations: [
        { name: "pig_idle", weight: 14 },
        { name: "pig_idle2", weight: 6 },
        { name: "pig_chuckling", weight: 1 },
        { name: "pig_laughing", weight: 1 },
        { name: "pig_happy_jumping", weight: 1 },
        { name: "pig_sleeping", weight: 1 }
    ],
    scaredAnimation: ["pig_scared_jump", "pig_scared"],
    scaredRadius: 20,
    animateWhileMovingThreshold: 0.15 // If the movement speed is within this threshold, then don't play idle animations
};
export var CardSettings = {
    birdOptions: [
        { fromTurn: 0, lastTurn: 1, options: [
                { bird: NameSettings.redBird, chance: 1, max: 2 },
                { bird: NameSettings.blueBird, chance: 1, max: 1 },
                { bird: NameSettings.yellowBird, chance: 1, max: 2 },
                { bird: NameSettings.bigBird, chance: 0, max: 1 },
                { bird: NameSettings.matilda, chance: 0, max: 1 }
            ] },
        { fromTurn: 2, lastTurn: 3, options: [
                { bird: NameSettings.redBird, chance: 1, max: 2 },
                { bird: NameSettings.blueBird, chance: 1, max: 1 },
                { bird: NameSettings.yellowBird, chance: 1, max: 2 },
                { bird: NameSettings.blackBird, chance: 1, max: 1 },
                { bird: NameSettings.bigBird, chance: 2, max: 1 },
                { bird: NameSettings.matilda, chance: 1, max: 1 }
            ] },
        { fromTurn: 4, lastTurn: 999, options: [
                { bird: NameSettings.redBird, chance: 1, max: 2 },
                { bird: NameSettings.blueBird, chance: 1, max: 1 },
                { bird: NameSettings.yellowBird, chance: 1, max: 2 },
                { bird: NameSettings.blackBird, chance: 99, max: 1 },
                { bird: NameSettings.bigBird, chance: 99, max: 1 },
                { bird: NameSettings.matilda, chance: 1, max: 1 }
            ] }
    ],
    cardsPerTurn: 3,
    maxTurnsPerPlayer: 15,
    terenceTimerDuration: 72,
    maxMatildaInvites: 3
};
export var PowerUpSlotSettings = {
    distanceBetweenPowerUpSlots: 130,
    leftMostPosition: -117,
    animationSpeedScalar: 1,
    addPowerupsButtonPosition: // DEPRECATED
    {
        x: 370,
        y: 43
    }
};
export var SlingshotFakeAimSettings = {
    animSpeed: 2.00
};
export var PowerUpSettings = {
    mightyScopeDuration: 7,
    mightyScopeServerTag: "mightyScopeEndTime",
    slingshotOffset: 10,
    shieldSettings: {
        health: 650, scale: 4
    },
    freezeRaySettings: {
        radius: 11,
        yOffset: 25,
        effectScale: 2.25,
        timeBetweenObjects: 20,
        timeBeforeStart: 30
    },
    stoneNatorSettings: {
        radius: 11,
        effectScale: 2.25,
        timeBetweenObjects: 20,
        timeBeforeStart: 30
    },
    pigSwapSettings: {
        animationScaleBig: 0.6,
        animationScaleMedium: 0.4,
        animationScaleSmall: 0.2,
        animationYOffset: 2
    },
    tntSettings: {
        yOffset: 10,
        maximumFallDistance: 25,
        damageRange: 8,
        pushRange: 15
    },
    selectedPowerUpIconScale: 1.1,
    options: [
        {
            kind: NameSettings.bombDrop,
            image: s_powerup_tnt,
            chance: 1,
            max: 2,
            bgImg: s_buttonpower_red,
            iconOffset: { x: 0, y: 0 },
            desc: "PU_TUT_TNT_TEXT",
            smokePuff: "s_smoke_puff_red"
        },
        {
            kind: NameSettings.shield,
            image: s_powerup_shield,
            chance: 1,
            max: 2,
            iconOffset: { x: 5, y: 5 },
            bgImg: s_buttonpower_teal,
            desc: "PU_TUT_SHIELD_TEXT",
            smokePuff: "s_smoke_puff_teal"
        },
        {
            kind: NameSettings.freezeRay,
            image: s_powerup_freeze,
            chance: 1,
            max: 2,
            bgImg: s_buttonpower_blue_light,
            iconOffset: { x: 0, y: 0 },
            desc: "PU_TUT_ICE_TEXT",
            smokePuff: "s_smoke_puff_ice"
        },
        {
            kind: NameSettings.stoneNator,
            image: s_powerup_stone_nator,
            chance: 1,
            max: 2,
            iconOffset: { x: 0, y: 0 },
            bgImg: s_buttonpower_grey,
            desc: "PU_TUT_STONE_TEXT",
            smokePuff: "s_smoke_puff_purple"
        },
        {
            kind: NameSettings.swapPigs,
            image: s_powerup_pig_swap,
            chance: 1,
            max: 2,
            bgImg: s_buttonpower_green,
            iconOffset: { x: 3, y: 6 },
            placementDelay: 2500,
            desc: "PU_TUT_TELEPORT_TEXT",
            smokePuff: "s_smoke_puff_pig_green"
        }
    ],
    cannotSwapPigsMessage: "SWAP_ERROR_TEXT",
    startingSlotAmount: 3,
    maxSlotAmount: 3,
    regenerationTime: 5,
    timeBetweenPlacementAndAction: 1000,
    timeBetweenActionAndResume: 1500,
    placementIconScale: 1.00,
    powerUpBarAnims: {
        speed: 1.0,
        powerupDescriptionDistance: 200,
        panSpeed: 0.1,
        zoomSpeed: 0.1 // Scalar for how fast the camera zooms out when powerup is selected
    },
    adCooldown: 1 * 1000 // in ms
};
export var ScoreSettings = {
    pig: 5000,
    block: 500,
    damageMultiplier: 10,
    floaterThreshold: 100,
    floaterDuration: 900,
    floaterMoveDist: 3.5,
    floaterDurationText: 1500,
    floaterMoveDistText: 5,
    floaterScale: 2,
    floaterTextOptions: { fontFace: angrybirds_regular.fontFace, fontSize: 20, fillColor: "white", strokeWidth: 2, strokeColor: "#214308" },
    floaterTextOptionsText: { fontFace: angrybirds_regular.fontFace, fontSize: 50, fillColor: "white", strokeWidth: 4, strokeColor: "#214308" },
    textFloaterOffset: 6,
    pigKillFontSize: 40,
    enemyPigKillMessages: ["PIG_HIT_1_TEXT", "PIG_HIT_2_TEXT", "PIG_HIT_3_TEXT", "PIG_HIT_4_TEXT", "PIG_HIT_5_TEXT"],
    enemyPigKillColor: "#4bea2d",
    allyPigKillMessages: ["OWN_PIG_HIT_1_TEXT", "OWN_PIG_HIT_2_TEXT", "OWN_PIG_HIT_3_TEXT"],
    allyPigKillColor: "#e81414",
    allyPigKillStrokeColor: "#faffff",
    killstreakMessages: { 2: "PIG_HIT_COMBO_1_TEXT", 3: "PIG_HIT_COMBO_2_TEXT", 4: "PIG_HIT_COMBO_3_TEXT", 5: "PIG_HIT_COMBO_4_TEXT", 6: "PIG_HIT_COMBO_5_TEXT" },
    killstreakGrowth: 12
};
export var GraphicsSettings = {
    textOutlineMain: "#003563",
    textOutline: "#5b0315",
    hudOffsetX: 0,
    hudOffsetY: 10,
    hudScaleX: 1,
    hudScaleY: 1,
    hudHideSpeed: 1.2,
    hudShowSpeed: 1.4,
    winScreenBGRotationSpeed: 0.5,
    uiWaitTimeAfterImpact: 2000 // time after first impact that the UI should become available (between shots)
};
export var EffectsSettings = {
    redAnimationSpeed: 1.6,
    explosionScaleFactor: 0.5,
    redScaleFactor: 1
};
export var AbilitySettings = {
    red: { force: 175, range: 20, spread: 0.5 }
};
export var KillerPlanes = {
    left: -80,
    right: 180,
    top: -150,
    bottom: 50,
    pigsBottom: 2
};
export var BalloonSettings = {
    accelerationSpeed: 1.0,
    shrinkSpeed: 1.0 // How fast the balloon shrinks; 1.0 == 100% speed
};
export var ReplaySettings = {
    shotPanDelay: 1.5,
    powerupPanDelay: 1.5
};
export var FriendInvites = {
    inviteMax: 3
};
export var CustomUpdateSettings = {
    playerNameLimit: 10,
    imageTextFont: {
        fontFamily: 'angrybirds_regular', fontSize: 45, fill: '0xfefefe', align: 'center', dropShadow: 'true', fontWeight: 'bold', fontStyle: 'normal', padding: 10
    },
    inviteMessage: ["GAME_INVITE_TEXT_1", "GAME_INVITE_TEXT_2", "GAME_INVITE_TEXT_3"],
    inviteCTA: ["GAME_INVITE_CTA_TEXT_1", "GAME_INVITE_CTA_TEXT_2", "GAME_INVITE_CTA_TEXT_3"],
    inviteImgText: ["WANTS TO PLAY!", "WANTS TO PLAY!", "WANTS TO PLAY!"],
    inviteTags: ["invite_01", "invite_02", "invite_03"],
    turnMessages: [
        "YOUR_TURN_1_TEXT",
        "YOUR_TURN_2_TEXT",
        "YOUR_TURN_3_TEXT",
        "YOUR_TURN_4_TEXT",
        "YOUR_TURN_5_TEXT",
        "YOUR_TURN_6_TEXT",
        "YOUR_TURN_7_TEXT",
        "YOUR_TURN_8_TEXT",
        "YOUR_TURN_9_TEXT",
        "YOUR_TURN_10_TEXT",
        "YOUR_TURN_11_TEXT",
        "YOUR_TURN_12_TEXT"
    ],
    turnCTA: [
        "YOUR_TURN_CTA_1_TEXT",
        "YOUR_TURN_CTA_2_TEXT",
        "YOUR_TURN_CTA_3_TEXT",
        "YOUR_TURN_CTA_4_TEXT",
        "YOUR_TURN_CTA_5_TEXT",
        "YOUR_TURN_CTA_6_TEXT",
        "YOUR_TURN_CTA_7_TEXT",
        "YOUR_TURN_CTA_3_TEXT",
        "YOUR_TURN_CTA_5_TEXT",
        "YOUR_TURN_CTA_8_TEXT",
        "YOUR_TURN_CTA_1_TEXT",
        "YOUR_TURN_CTA_4_TEXT"
    ],
    turnImgText: "YOUR TURN!",
    endMessage: "RESULT_TEXT",
    endCTA: 'RESULT_CTA_TEXT',
    pokeMessage: "POKE_MSG_TEXT",
    pokeCTA: "POKE_CTA_TEXT",
    pokeImgText: "POKE_IMG_TEXT"
};
export var GamebotSettings = {
    delays: [
        24 * 3600000,
        72 * 3600000,
        120 * 3600000,
        168 * 3600000,
        216 * 3600000
    ],
    messages: [
        {
            message: "BOT_MSG_1_TEXT",
            imageUrl: "https://www.dropbox.com/s/f5u9q3da77luyaz/custom_generic03.png?dl=1",
            CTA: "BOT_CTA_1_TEXT"
        },
        {
            message: "BOT_MSG_2_TEXT",
            imageUrl: "https://www.dropbox.com/s/tzzg9o0s9l0n5fd/custom_generic02.png?dl=1",
            CTA: "BOT_CTA_2_TEXT"
        },
        {
            message: "BOT_MSG_3_TEXT",
            imageUrl: "https://www.dropbox.com/s/f5u9q3da77luyaz/custom_generic03.png?dl=1",
            CTA: "BOT_CTA_3_TEXT"
        },
        {
            message: "BOT_MSG_4_TEXT",
            imageUrl: "https://www.dropbox.com/s/m0y64gs5err7syf/custom_generic04.png?dl=1",
            CTA: "BOT_CTA_4_TEXT"
        },
        {
            message: "BOT_MSG_5_TEXT",
            imageUrl: "https://www.dropbox.com/s/5p7abqyum68vvzo/custom_generic05.png?dl=1",
            CTA: "BOT_CTA_5_TEXT"
        }
    ]
};
// Only if it fits nowhere else and is uncategorisable
export var MiscSettings = {
    blocksNearSlingshotDistance: 7,
    matchmakingEllipsisSpeed: 500,
    playHistorySize: LevelSettings.levelList.length,
    levelExportMode: false,
    closeButtonTouchMargin: 20,
    exclamationMarkPowerUpMin: 2,
    numberOfSuggestedFriends: 5,
    noInterstitialsTimerDuration: 0 * 60000
};
export var DialogSettings = {
    headingHeight: -245,
    headingFont: {
        fontFace: angrybirds_regular.fontFace,
        fontSize: 34,
        fillColor: "#fefefe",
        align: "center",
        baseline: "middle"
    },
    textFont: {
        fontFace: angrybirds_regular.fontFace,
        fontSize: 36,
        fillColor: "#fefefe",
        align: "center",
        baseline: "middle",
        shadow: { active: true, color: 'rgba(50, 49, 65, 0.7)', offsetX: 2, offsetY: 3, blur: 1, distance: 3 }
    },
    textFontSmall: {
        fontFace: angrybirds_regular.fontFace,
        fontSize: 24,
        fillColor: "#fefefe",
        align: "center",
        baseline: "middle",
        shadow: { active: true, color: 'rgba(50, 49, 65, 0.7)', offsetX: 2, offsetY: 3, blur: 1, distance: 3 }
    },
    powerupCountFont: {
        fontFace: angrybirds_regular.fontFace,
        fontSize: 36,
        align: "center",
        baseline: "middle",
        fillColor: "#531c01",
        fontStyle: 'bold',
        shadow: { active: false }
    },
    expFont: {
        fontFace: angrybirds_regular.fontFace,
        fontSize: 40,
        fillColor: "#00e022",
        align: "center",
        baseline: "middle",
        shadow: { active: false }
    },
    rankFont: {
        fontFace: angrybirds_regular.fontFace,
        fontSize: 50,
        align: "center",
        baseline: "middle",
        fillColor: "#531c01",
        fontStyle: 'bold',
        shadow: { active: false }
    },
    buttonFont: {
        fontFace: angrybirds_regular.fontFace,
        fontSize: 42,
        fillColor: "#fefefe",
        align: "center",
        baseline: "middle",
        shadow: { active: true, color: 'rgba(50, 49, 65, 0.7)', offsetX: 2, offsetY: 3, blur: 1, distance: 4 }
    },
    buttonFontSmall: {
        fontFace: angrybirds_regular.fontFace,
        fontSize: 26,
        fillColor: "#fefefe",
        align: "center",
        baseline: "middle",
        shadow: { active: true, color: 'rgba(50, 49, 65, 0.7)', offsetX: 2, offsetY: 3, blur: 1, distance: 4 }
    }
};
